import { h } from 'preact';
import ProgressRing from '../progress-ring';
import CrossCloseSvg from '../cross-close-svg';

type Props = {
  closingScheduledIn?: number;
  isCross?: boolean;
  isDisabled?: boolean;
  closeDelay?: number;
  elapsedTime: number;
  clickCloseTime?: number;
};

export default function CloseControl(
  {
    closingScheduledIn,
    isCross,
    isDisabled,
    elapsedTime,
    clickCloseTime = 0
  }: Props,
  context: { translate: (key: string, args?: Record<string, any>) => string }
) {
  if (isCross) {
    return clickCloseTime ? (
      <ProgressRing
        timeToComplete={closingScheduledIn}
        size={18}
        strokeWidth={1}
        elapsedTime={elapsedTime}
        clickCloseTime={clickCloseTime}
      />
    ) : (
      <CrossCloseSvg
        color={`rgba(255, 255, 255, ${isDisabled ? 0.5 : 1})`}
        size={16}
      />
    );
  }
  return closingScheduledIn ? (
    <span
      data-zone="close"
      dangerouslySetInnerHTML={{
        __html: context.translate('wait_close', {
          count: Math.round(closingScheduledIn - (elapsedTime - clickCloseTime))
        })
      }}
    />
  ) : (
    <span
      data-zone="close"
      dangerouslySetInnerHTML={{ __html: context.translate('continue') }}
    />
  );
}
